<div class="flex w-screen h-screen place-content-center place-items-center">
  <div class="flex flex-col place-items-center m-8">
    <div class="text-3xl">Ooooohhhh...</div>
    <div class="text-center">Diese Ressource ist leider für dich nicht zugelassen.</div>
  </div>
</div>
